import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/grailed-photo-tips';

export default function Example() {
  return (
    <>
      <Head>
        <title>Grailed photo tips: Guidelines and checklist to follow for successful listings</title>
        <meta
          name='description'
          content="On Grailed, having irresistible goods to sell is not enough. Your photos must be complete and of high quality to meet the moderators' standards. Here's how to get it right every time you list."
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/grailed-photo-tips' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/grailed-photo-tips' />
        <meta
          property='og:title'
          content='Grailed photo tips: Guidelines and checklist to follow for successful listings'
        />
        <meta
          property='og:description'
          content="On Grailed, having irresistible goods to sell is not enough. Your photos must be complete and of high quality to meet the moderators' standards. Here's how to get it right every time you list."
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-04-29T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-04-29T00:00:00-00:00' />
        <meta property='article:tag' content='Grailed' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
